<template>
  <div class="content">
    <div class="header">
      <h1>{{ pageTitle }}</h1>
    </div>
    <Spin fix v-if="loading"></Spin>
    <div class="content-body table-wrapper">
    <Row :gutter="32">
      <Col span="18">
        <div class="quote-preiview-page">
        <div class="text-align-right quick-links">
          <router-link :to="{ name: 'menu.quote.edit', params: { quoteId: quoteId } }">
            &lt;&lt; Go back to quote page
          </router-link>
        </div>
        <div class="pdf-container" style="background: white">
        <div class="pdf-wraper">
          <div class="a4" id="pdf-content">
            <Row class="header">
              <Col span="13">
                <strong>{{data.accounting_company_name}}</strong>
                <div v-html="data.accounting_company_address">
                  {!data.accounting_company_address}
                </div>
              </Col>
              <Col span="10" offset="1">
                <img :src="logo" height="50" />
              </Col>
            </Row>
            <Row>
              <Col span="16">
                <h2 class="estimate-label">{{data.estimate_label}}</h2>
                <!-- <p>{{ data.title }}</p> -->
              </Col>
            </Row>
            <Row>
              <Col span="16">
                <h4>CUSTOMER</h4>
                <br>
                <p>{{ data.customer.name }}</p>
                <p>{{ data.address }}</p>
                  <p v-if="data.city">{{ data.city }}</p>
                <p>
                  <span v-if="data.postal_code"> {{ data.postal_code }}</span>
                  <span v-if="data.state"> {{ data.state }}</span>
                </p>
                <p v-if="data.country"> {{ data.country }}</p>
                <br>
                <h4>CONTACT</h4>
                <br>
                <p style="font-weight-bold">
                  <span v-if="data.contact_first_name">{{ data.contact_first_name }}</span>
                  <span v-if="data.contact_last_name">&nbsp;{{ data.contact_last_name }}</span>
                </p>
                <br>
                <p v-if="data.contact_email">{{ data.contact_email }}</p>
                <p v-if="data.contact_phone">Shipping contact number {{ data.contact_phone + ' ('  + data.contact_first_name  + ')' }}</p>
              </Col>
              <Col span="8">
                <p>Reference:&nbsp;{{ data.estimate_number }}</p>
                <p>Created at:&nbsp;{{ dateFormatted(data.date) }}</p>
                <p>Expires at:&nbsp;{{ dateFormatted(data.valid_until) }}</p>
                <br />
                <p><strong>Terms:</strong>&nbsp;{{ data.terms }}</p>
              </Col>
            </Row>
            <Divider></Divider>
            <Row>
              <Col span="24">
                <!-- <Table v-if="data" class="items" :columns="columns" :data="tableData"
                  :summary-method="handleItemsSummary" show-summary></Table> -->
                  <section class="line-items" aria-label="line-items">
                    <div id="">
                        <table class="line-items__table">
                            <thead>
                                <tr>
                                    <th scope="col">PRODUCTS &amp; SERVICES</th>
                                    <th scope="col">DESCRIPTION</th>
                                    <th scope="col">QUANTITY</th>
                                    <th scope="col">UNIT PRICE</th>
                                    <th scope="col">TOTAL</th>
                                </tr>
                            </thead>
                            <tbody id="line-items__table-body">
                              <tr v-for="item in tableData" :key="item.id">
                                <td>{{ item.title }}</td>
                                <td></td>
                                <td>{{ item.quantity }}</td>
                                <td>{{ currencyFormatted(item.currency, item.unit_price) }}</td>
                                <td>{{ currencyFormatted(item.currency, item.line_total) }}</td>
                              </tr>
                            </tbody>
                        </table>
                    </div>
                    <div id="items_">
                        <div class="line-items__total">
                            <div class="line-items__total-name">Total</div>
                            <div class="line-items__total-value">{{ currencyFormatted(currency, calculateSum('line_total', tableData))  }}</div>
                        </div>
                    </div>
                  </section>

              </Col>
            </Row>
            <Row class="additional" v-if="data.additional_text && data.additional_text.length > 0">
              <Col span="24">
                <p v-html="data.additional_text"></p>
              </Col>
            </Row>
            <br>
            <br>
            <!-- <Row>
              <Col span="12">
                <p><strong>Accepted By</strong></p>
              </Col>
              <Col span="12">
                <p><strong>Accepted Date</strong></p>
              </Col>
            </Row> -->
          </div>
        </div>
        </div>
        <div class="actions text-align-right">
          <div class="margin-bottom-20">
            <i-switch v-model="switchPrice" @on-change="handleChangePrice" class="margin-right-10" />
            <span>{{ $t('menu.quote.switch_price') }}</span>
          </div>
          <Button type="warning" size="large" @click="handleDownload" :disabled="disableDownloadBtn">{{ $t('menu.quote.download_price_quotation') }}</Button>
          <Button type="primary" size="large" @click="showEditDrawer = true">{{ $t('menu.quote.edit_price_quotation') }}</Button>
        </div>
        </div>
      </Col>
      <Col span="6">
        <div class="submitions">
          <QuotePdfList :quoteId="quoteId" :key="pdfListReload" @onPopulate="handlePopulatePdf" @onSetDefaultDocument="handleDefaultDocumentSetting"></QuotePdfList>
        </div>
      </Col>
    </Row>
    </div>
    <Drawer v-model="showEditDrawer" title="Make quotation" width="650">
      <QuotationMakeForm :document-id="documentId" :quote-id="quoteId" @on-saved="handleUpdatePDFData" :key="quoteMakeFormReload"></QuotationMakeForm>
    </Drawer>
  </div>
</template>

<script>
// import { jsPDF } from 'jspdf'
// import autoTable from 'jspdf-autotable'
// import html2pdf from 'html2pdf.js'
import { mapActions } from 'vuex'
import { intlCurrencyNumber } from '@/libs/util'
import QuotationMakeForm from './components/forms/quotation-make-form'
import QuotePdfList from './components/widgets/quote-pdf-list.vue'
import logo from '@/assets/images/logo.png'
// import '@/components/jspdf/fonts/noto-normal.js'
// import '@/components/jspdf/fonts/noto-bold.js'
import FieldsDef from './data/price-quotation-items-fields'
import moment from 'moment'
export default {
  name: 'QuotePreview',
  components: {
    QuotationMakeForm,
    QuotePdfList
  },
  data () {
    return {
      logo,
      data: {
        currency: '',
        customer: { name: '' },
        estimate_label: 'ESTIMATE',
        accounting_company_name: 'NexGroup Inc.',
        accounting_company_address: '<p>100 TradeCenter, Suite G-700</p><p>MA US</p>',
        date: new Date(),
        valid_until: moment().add(2, 'months').toDate(),
        contact_email: '',
        contact_phone: '',
        contact_first_name: '',
        contact_last_name: '',
        address: '',
        estimate_number: '',
        additional_text: `<h3>TERMS & CONDITIONS</h3>
        <ol>
        <li>This estimate includes XXX. (我们提供的服务内容)</li>
        <li>This estimate does not include XXX. (说明该报价不包含的内容)</li>
        <li>This estimate expire date is 14 days. If there are unforeseen objective circumstances, the quotation may be changed accordingly.</li>
        <li>The payment term standard is 100% pre-payment. (这里想说明的是付款条件默认是100% 预付。但批量的情况我们可以再谈。)</li>
        </ol>`
      },
      loading: false,
      columns: [],
      showEditDrawer: false,
      quoteId: Number.parseInt(this.$route.params.quoteId),
      documentId: this.$route.params.documentId ? this.$route.params.documentId : '',
      tableData: [],
      currency: this.data && this.data.currency,
      switchPrice: true,
      disableDownloadBtn: false,
      pdfListReload: 0,
      quoteMakeFormReload: 0
    }
  },
  mounted () {
    this.loading = true
  },
  created () {
    this.changeColumns()
  },
  computed: {
    pageTitle () {
      document.title = this.$t('menu.quote.price_quotation_page')
      return document.title
    }
  },
  methods: {
    ...mapActions([
      'loadQuote',
      'getQuoteItems',
      'getSinglePDF',
      'downloadQuotation'
    ]),
    handleItemsSummary ({ columns, data }) {
      const sums = {}
      columns.forEach((col, index) => {
        const key = col.key
        if (index === 0) {
          sums[key] = { key, value: '' }
          return
        }

        if (key === 'quantity') {
          sums[key] = { key, value: 'Total' }
          return
        }

        const values = data.map(item => {
          return item.line_total || 0
        })
        if (key === 'sub_total') {
          const value = values.reduce((sum, curr) => {
            return sum + curr
          }, 0)

          sums[key] = { key, value: intlCurrencyNumber(this.currency, value, 2, 2) }
        } else {
          sums[key] = { key, value: '' }
        }
      })
      return sums
    },
    dateFormatted(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    currencyFormatted(currency, amount) {
      return intlCurrencyNumber(currency, amount, 2, 2)
    },
    calculateSum(property, data) {
      return data.map(item => {
        return item[property] || 0
      }).reduce((sum, curr) => {
        return sum + curr
      }, 0)
    },
    handleDownload () {
      this.loading = true
      this.downloadQuotation({ quoteId: this.quoteId, documentId: this.documentId }).then(resp => {
        const url = window.URL.createObjectURL(new Blob([resp.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `nexpcb-quotation-${this.quoteId}-${this.documentId}-${this.data.estimate_number}.pdf`)
        document.body.appendChild(link)
        link.click()
      }).finally(() => {
        this.loading = false
      })
    },
    handleUpdatePDFData (data, flag) {
      this.data = Object.assign(this.data, data)
      this.documentId = data.documentId
      this.disableDownloadBtn = !this.documentId
      this.showEditDrawer = flag
      this.reloadPdfList()
    },
    handleChangePrice (status) {
      this.switchPrice = status
      this.changeColumns()
    },
    handlePopulatePdf(pdfData) {
      this.data = Object.assign(this.data, pdfData)
      this.documentId = pdfData.id
      this.disableDownloadBtn = !this.documentId
      this.reloadQuoteMakeForm()
    },
    handleDefaultDocumentSetting(defaultDocument) {
      if (!this.documentId) {
        this.documentId = defaultDocument ? defaultDocument.id : 0
      }
      this.disableDownloadBtn = !this.documentId
      this.reloadQuoteMakeForm()
      this.loadQuotationDetails()
    },
    loadQuotationDetails () {
      if (this.documentId) {
        this.getSinglePDF({ quoteId: this.quoteId, documentId: this.documentId }).then(resp => {
          this.data = resp.data
          this.loadQuote(this.quoteId).then(resp => {
            this.$set(this.data, 'customer', resp.data.customer)
          })
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.loadQuote(this.quoteId).then(resp => {
          if (resp.data.customer) {
            this.data.customer = resp.data.customer
          }
          this.data.title = resp.data.title
          this.data.currency = resp.data.currency
          this.data.customer_id = resp.data.customer_id
          this.data.exchange_rate = resp.data.exchange_rate
          this.data.estimate_number = resp.data.number
          this.data.valid_until = resp.data.expires_date
        }).finally(() => { this.loading = false })
      }
      this.getQuoteItems({
        quoteId: this.quoteId
      }).then(resp => {
        this.tableData = resp.data
      }).finally(() => {
        this.loading = false
      })
    },
    changeColumns () {
      let sourceColumns = FieldsDef.columns
      if (!this.switchPrice) {
        let noPriceColumns = sourceColumns.filter((item) => {
          return item.title !== 'Price'
        })
        this.columns = noPriceColumns
      } else {
        this.columns = sourceColumns
      }
    },
    reloadPdfList() {
      this.pdfListReload++
    },
    reloadQuoteMakeForm() {
      this.quoteMakeFormReload++
    }
  },
  watch: {
    'data.currency': function () {
      this.currency = this.data.currency
    }
  }
}
</script>

<style lang="less" scope>
.header h2 { margin-top: 0; }
.quote-preiview-page, .quick-links, .actions {
  width: 795px;
  margin: 15px auto 15px auto;
}
.pdf-container {
  border: 1px solid #ccc;
}

.pdf-wraper{
  width: 670px;
  padding: 128px 0px;
  margin: 0 auto;
  // font-family: 'noto';
  font-size: 12px;
  .a4 {
    background: white;
    display: block;
    margin: 0 auto;
    box-sizing: border-box;
  }
  .estimate-label {
    font-size: 26px;
    color: #366;
  }
}
.submitions{
  margin: 50px;
}
.items { margin-top: 30px; }
.additional { margin-top: 30px; font-size: 12px; ul { margin-left: 30px; }}
.quote-preiview-page .ivu-table-summary .ivu-table-cell { font-size: 120%; font-weight: bold; }
.line-items{
  .line-items__table {
    width: 100%;
    border: 1px solid;
    border-collapse: collapse;

    td, th {
      height: inherit !important;
      height: 4em;
      border-width: 1px 0px 0px;
      border-style: solid;
      border-color: rgba(245, 245, 245, 1);
      text-align: right;
    }

    th {
      font-weight: bold;
      padding: 0.57em;
    }

    td {
        padding: 1.14em 1.71em;
        hyphens: auto;
        overflow-wrap: break-word;
    }
    tr>th:first-child,
    tr>td:first-child,
    tr>th:last-child,
    tr>td:last-child {
        padding: 0.57em 1.71em;
    }

    tr>th:first-child,
    tr>td:first-child {
        text-align: left;
    }
  }
  .line-items__total {
    width: 300px;
    display: flex;

      & > div {
        height: 56px;
        padding: 0 24px;
        line-height: 56px;
        margin-top: 24px;
      }
  }
  .line-items__total-name {
    width: 50%;
    text-align: left;
    font-weight: bold;
    border-width: 0px 1px 0px 0px;
    border-style: solid;
    background-color: #6d9eeb;
  }

  .line-items__total-value {
    text-align: right;
    margin-left: auto;
    width: 50%;
    margin-top: 24px;

  }

  table, td {
    background-color: rgba(245, 245, 245, 1);
    border-color: rgba(245, 245, 245, 1) !important;
  }

  th, .line-items__total-name {
    background-color: #6d9eeb !important;
  }
}
</style>
